import {
  BuildingLibraryIcon,
  NewspaperIcon,
  ClipboardDocumentListIcon,
  EnvelopeIcon,
  BriefcaseIcon,
} from "@heroicons/react/24/solid";

import { PERMISSIONS, ROUTE_PATHS } from "../../PermissionsConstants";
import EmployeeStatus from "./EmployeeStatus";
import EmployeeTitle from "./EmployeeTitle";
import EmployeeType from "./EmployeeType";
import EmploymentType from "./EmploymentType";
import EmailDomain from "./EmailDomains";
import EmployeeBilingual from "./EmployeeBilingual";
import EmployeeReportsTo from "./EmployeeReportsTo";
import HomeCompany from "./HomeCompanyConfig";
import { EmployeeAdOverrideGroup } from "./ADOverrideGroup/view";

export const EmployeeTabs = [
  {
    to: ROUTE_PATHS.Utilities_EmployeeType_EmployeeType_Index,
    icon: <NewspaperIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Employee Type",
    component: EmployeeType,
    permission: PERMISSIONS.permission_utilities_employeetype_employeetype_view,
  },
  {
    to: ROUTE_PATHS.Utilities_EmployeeType_EmployeeStatus_Index,
    icon: <BuildingLibraryIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Employee Status",
    component: EmployeeStatus,
    permission:
      PERMISSIONS.permission_utilities_employeetype_employeestatus_view,
  },
  {
    to: ROUTE_PATHS.Utilities_EmployeeType_EmploymentType_Index,
    icon: <ClipboardDocumentListIcon className="h-4 w-4 float-left mr-2" />,
    title: "Employment Type",
    component: EmploymentType,
    permission:
      PERMISSIONS.permission_utilities_employeetype_employmenttype_view,
  },
  {
    to: ROUTE_PATHS.Utilities_EmployeeTiTle_Index,
    icon: <BriefcaseIcon className="h-4 w-4 float-left mr-2" />,
    title: "Employee Title",
    component: EmployeeTitle,
    permission:
      PERMISSIONS.permission_utilities_employeetype_employeetitle_view,
  },
  {
    to: ROUTE_PATHS.Utilities_EmailDomain_Index,
    icon: <EnvelopeIcon className="h-4 w-4 float-left mr-2" />,
    title: "Email Domain",
    component: EmailDomain,
    permission: PERMISSIONS.permission_utilities_emaildomain_view,
  },
  {
    to: ROUTE_PATHS.Utilities_EmployeeBilingual_Index,
    icon: <EnvelopeIcon className="h-4 w-4 float-left mr-2" />,
    title: "Employee Bilingual",
    component: EmployeeBilingual,
    permission: PERMISSIONS.permission_utilities_employeebilingual_view,
  },
  {
    to: ROUTE_PATHS.Utilities_EmployeeReportsTo_Index,
    icon: <BriefcaseIcon className="h-4 w-4 float-left mr-2" />,
    title: "Employee Reports To",
    component: EmployeeReportsTo,
    permission: PERMISSIONS.permission_utilites_employeeReportsTo_view,
  },
  {
    to: ROUTE_PATHS.Utilities_HomeCompany_Index,
    icon: <BriefcaseIcon className="h-4 w-4 float-left mr-2" />,
    title: "Home Company",
    component: HomeCompany,
    permission: PERMISSIONS.permission_utilities_homecompany_type_view,
  },
  {
    to: ROUTE_PATHS.Utilities_AdOverrideGroup_Index,
    icon: <BriefcaseIcon className="h-4 w-4 float-left mr-2" />,
    title: "AD Override Group",
    component: EmployeeAdOverrideGroup,
    permission: PERMISSIONS.permission_utilities_employeeadoverridegroup_view,
  },
];
